function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import map from 'lodash/map';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../actions';
import * as shapes from '../shapes';
import Scope from '../partials/Scope';
var _React_PureComponent;
class ChooseScope extends (_React_PureComponent = React.PureComponent) {
    onSetScope(input) {
        this.setState({
            formValues: {
                values: {
                    [input.id]: input.value
                }
            }
        });
    }
    onChooseScope() {
        this.setState({
            isInProgress: true
        });
        const scopeName = get(this.state.formValues, 'values.scopeName');
        const scope = find(this.state.scopes, {
            scope: scopeName
        });
        this.props.onChooseScope(scope);
    }
    get isDisabled() {
        return !get(this.state.formValues, 'values.scopeName');
    }
    render() {
        const scopesNames = map(this.state.scopes, (scope)=>scope.scope);
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(Scope, {
                    activeScopeNames: scopesNames,
                    formValues: this.state.formValues,
                    hideInactive: true,
                    onSetFormValue: (input)=>this.onSetScope(input)
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-8",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.continue,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        isInProgress: this.state.isInProgress,
                        onClick: ()=>this.onChooseScope()
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            scopes: props.scopes,
            formValues: {},
            isInProgress: false
        };
    }
}
_define_property(ChooseScope, "propTypes", {
    // Explicit props
    scopes: PropTypes.arrayOf(shapes.scope),
    // Explicit actions
    onChooseScope: PropTypes.func
});
// const mapStateToProps = (state) => ({
// });
const mapDispatchToProps = (dispatch)=>({
        onChooseScope: (scope)=>dispatch(actions.chooseScope(scope))
    });
const ConnectedChooseScope = connect(null, mapDispatchToProps)(ChooseScope);
export default ConnectedChooseScope;
